module.exports = __webpack_public_path__ + "static/media/icon-expand.165ba113.svg";